<template>
	<div
		class="w-full"
		:class="embedded ? '' : 'p-4 rounded-lg bg-neutral-800'"
	>
		<h5
			class="mb-2 font-medium text-white"
			:class="$lowercaseHeadingClass"
		>
			{{ $t(title) }}
		</h5>

		<ul class="mb-0">
			<li v-for="(item, index) in items" :key="index" class="flex my-1">
				<div
					class="w-1.5 h-1.5 mr-2 bg-white rounded-full flex-shrink-0 transform translate-y-[7px]"
				/>
				{{ $t(item) }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'ProfileHighlight',
	props: {
		title: {
			type: String,
			required: true
		},
		items: {
			type: Array,
			default: () => []
		},
		embedded: {
			type: Boolean,
			default: false
		}
	}
}
</script>
